import { useMemo } from 'react';
import { getNavItemsForRole } from './utils';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DynamicNavItem } from './DynamicNavItem';
import { useMyCohortStore } from '../../../../store/MyCohortStore';
import { useKeycloakStore, useUserMeStore } from '../../../../store';
import { inAppNavigation } from '../../../../hooks';

const useNavItems = (isMobile: boolean) => {
  const kcStore = useKeycloakStore();
  const store = useMyCohortStore();
  const userMeStore = useUserMeStore();
  const nachversandEligible =
    userMeStore.myInfo?.Participant?.nachversandEligible ?? null;
  const navigate = useNavigate();
  const { t } = useTranslation('navbar');
  const currentRole = kcStore.currentRealmRole;

  const navItemElements = useMemo(() => {
    if (!currentRole) return [];

    const navItems = getNavItemsForRole(
      currentRole,
      store.cohortType,
      nachversandEligible,
    );

    return navItems.map((item) => (
      <DynamicNavItem
        key={item.route}
        iconName={item.iconName}
        text={t('NavItems.' + item.text)}
        route={item.route}
        onClick={() => navigate(item.route, inAppNavigation)}
        isMobile={isMobile}
      />
    ));
  }, [
    currentRole,
    store.cohortType,
    nachversandEligible,
    t,
    isMobile,
    navigate,
  ]);

  return navItemElements;
};

export default useNavItems;
